/**
 * MAS Indirect template logic: FIELD_DEPENDENCIES for Indirect and recalculateFieldsIndirect.
 * Delegates to recalcCore with Indirect config (no blended fee).
 */

import type { RecalculateFieldsParams } from '../../shared/logic';
import { recalculateFieldsCore } from '../../recalcCore';
import { getIndirectRecalcConfig } from '../../recalcConfigBuilders';

/** MAS Indirect field dependencies (subset used by Indirect template). */
export const FIELD_DEPENDENCIES_INDIRECT: Record<string, string[]> = {
  'gsmsCostFromMfg': ['gsmsNetCostFromMfg', 'gsmsCost', 'gsmsProfit', 'suggestedBidPrice'],
  'gsmsNetCostFromMfg': ['gsmsCost', 'gsmsProfit', 'gsmsMarketingFee'],
  'gsmsIffFee': ['gsmsCost', 'gsmsProfit'],
  'suggestedBidPrice': ['gsmsIffFee', 'gsmsCost', 'gsmsProfit', 'gsmsMarketingFee', 'annualTmopSavings', 'monthlyTmopSavings', 'govSavingsAnalysis', 'contractAnnualRevenue', 'contractAnnualGP', 'contractAnnualCost'],
  'gsmsProfit': ['gsmsNetCostFromMfg', 'gsmsCost'],
  'gsmsCost': ['gsmsProfit'],
  'vaTmsPercent': ['totalTmsPercent', 'targetAnnualUsage'],
  'dodTmsPercent': ['totalTmsPercent', 'targetAnnualUsage'],
  'vaAnnualUsage': ['totalTmsPercent', 'targetAnnualUsage'],
  'dodAnnualUsage': ['totalTmsPercent', 'targetAnnualUsage'],
  'tmopPercent': ['annualTmopSavings', 'monthlyTmopSavings'],
  'lowestContractPrice': ['annualTmopSavings', 'monthlyTmopSavings', 'govSavingsAnalysis'],
};

/**
 * Recalculate fields for MAS Indirect template. Uses recalcCore with Indirect config.
 */
export function recalculateFieldsIndirect(params: RecalculateFieldsParams): Record<string, any> {
  return recalculateFieldsCore({ ...params, productType: 'indirect' }, getIndirectRecalcConfig(FIELD_DEPENDENCIES_INDIRECT));
}
